
<template>
  <div class="crew_right">
    <div class="conInner">
      <div class="data">
        <h2>我的资料</h2>
      </div>
      <div class="lm-con">
        <div class="inner">
          <div class="content">
            <div class='msgbox'>
              <p><span>店铺名称：{{leagueName}}</span></p>
              <p><span>电话号码：{{tel}}</span></p>
              <p><span>地址：{{attr}}</span></p>
              <p><span>市场{{legionName}}</span></p>
              <p v-if="status == 1 && notPassReason != '' && apply == 2">
                <span>拒绝原因：<em>({{notPassReason}})</em></span>
              </p>
            </div>
            <div>
              <div class='msgbox border_b'>
                <p>身份证照片（正反面）</p>
                <div class='img_box id_box'>
                  <div
                    class="demo-upload-list"
                    v-for="(item,index) in idImg"
                    :key="index"
                  >
                    <img :src='item'>
                    <div
                      class="demo-upload-list-cover"
                      v-show='idImg'
                    >
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item)"
                      ></Icon>
                    </div>
                  </div>

                </div>
              </div>
              <div class='msgbox border_b'>
                <p>营业执照照片</p>
                <div class='img_box'>
                  <div
                    class="demo-upload-list"
                    v-for="(item,index) in licenseImg"
                    :key="index"
                  >
                    <img :src="item">
                    <div
                      class="demo-upload-list-cover"
                      v-show='licenseImg'
                    >
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item)"
                      ></Icon>
                    </div>
                  </div>
                </div>
              </div>
              <div class='msgbox'>
                <p>门头横幅照片（请横向拍摄）</p>
                <div class='img_box'>
                  <div
                    class="demo-upload-list"
                    v-for="(item,index) in storeBannerImg"
                    :key="index"
                  >
                    <img :src="item" />
                    <div class="demo-upload-list-cover">
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item)"
                      ></Icon>

                    </div>
                  </div>

                </div>
              </div>
              <div class='msgbox'>
                <p>店面照片</p>
                <div class='img_box'>
                  <div
                    class="demo-upload-list"
                    v-for="(item,index) in shopImg"
                    :key="index"
                  >
                    <img :src="item" />
                    <div class="demo-upload-list-cover">
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item)"
                      ></Icon>

                    </div>
                  </div>
                </div>
              </div>
              <div
                class='regis_box'
                v-show='apply == 0'
              >
                <input
                  class="regis_ent"
                  type="button"
                  value="审核中"
                >
              </div>
            </div>
            <div>
              <div class='msgbox'>
                <p>商品图片</p>
                <div class='img_box'>
                  <div
                    class="demo-upload-list"
                    v-for="(item,index) in goodsImg"
                    :key="index"
                  >
                    <img :src="item" />
                    <div class="demo-upload-list-cover">
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item)"
                      ></Icon>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <Modal
              title="图片预览"
              v-model="visible"
            >
              <img
                :src="showImageUrl"
                v-if="visible"
                style="width: 100%"
              />
            </Modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { isApplyLeague, findMemberLeague } from "api/user";

export default {
  data() {
    return {
      status: "", //1联盟商家资料;2商品图片
      apply: "", //审核状态 0待审核 1审核通过 2审核不通过 状态0不能修改记录
      sn: "", //联盟商家标识，编号
      leagueName: "", //联盟商家店铺名称
      attr: "", //地址
      tel: "", //电话
      leagueId: "", //联盟商家id
      notPassReason: "", //拒绝理由
      idImg: [], //身份证图片
      licenseImg: [], //营业执照图片
      storeBannerImg: [], //店面横幅图片
      shopImg: [], //店铺照片
      goodsImg: [], //商品图图片
      applyStatus: "", //是否可编辑0：通过不通过 1：审核中
      showImageUrl: "", //预览图片地址
      visible: false, //预览图片是否显示
      legionName: "", // 所属市场
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.status != from.query.status) {
        this.status = to.query.status;
        this.init(); //重新加载数据
      }
    },
  },
  created() {
    this.init();
    this.isApplyLeague();
  },
  methods: {
    init() {
      if (!this.$route.query.status) {
        this.status = 1;
      } else {
        this.status = Number(this.$route.query.status);
      }
    },
    //查询是否申请过联盟商家
    isApplyLeague() {
      isApplyLeague({}).then((res) => {
        if (res.data) {
          if (res.resCode == 1) {
            this.sn = res.data.sn;
            this.applyStatus = res.data.status;
            if (this.applyStatus == 2) {
              this.findMemberLeague();
            } else {
              return;
            }
          }
        }
      });
    },
    //查询联盟商家信息
    findMemberLeague() {
      findMemberLeague({}).then((res) => {
        // console.log(json)
        if (res.resCode == 1) {
          let data = res.data;
          this.apply = data.status;
          this.attr = data.attr;
          this.tel = data.tel;
          this.leagueId = data.leagueId;
          this.leagueName = data.leagueName;
          this.imageHost = data.imageHost;
          this.notPassReason = data.notPassReason;
          this.legionName = data.legionName;
          if (data.idImg) {
            this.idImg = this.toArr(data.idImg);
          }
          if (data.licenseImg) {
            this.licenseImg = this.toArr(data.licenseImg);
          }
          if (data.storeBannerImg) {
            this.storeBannerImg = this.toArr(data.storeBannerImg);
          }
          if (data.goodsImg) {
            this.goodsImg = this.toArr(data.goodsImg);
          }
          if (data.shopImg) {
            this.shopImg = this.toArr(data.shopImg);
          }
        } else {
          layer.msg(res.resDesc, { icon: 2 });
          return;
        }
      });
    },
    handleView(imageUrl) {
      this.showImageUrl = imageUrl;
      this.visible = true;
    },
    //将图片字符串转数组
    toArr(str) {
      if (str) {
        var _str = str.split(",");
        return _str;
      }
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.box > .ivu-tabs > .ivu-tabs-bar {
  margin-bottom: 0 !important;
  border-bottom: none;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  color: #000;
  font-size: 12px;
  background: #eeeeee;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  background: #fff;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav:first-child {
  margin-left: 22px;
}

.lm-con {
  width: 100%;
  min-height: 500px;
  background: #ffffff;
  border-top: #dfdfdf 1px solid;
  .inner {
    width: 960px;
    margin: 0 auto;
    padding-bottom: 36px;
    .msg {
      width: 100%;
      height: 30px;
      line-height: 30px;
      margin-top: 20px;
      font-weight: bold;
      font-size: 16px;
      color: #666;
    }
    h2 {
      padding: 30px 0 20px;
      font-size: 24px;
      font-weight: 400;
      text-align: center;
    }
    .content {
      width: 60%;
      font-size: 14px;
      padding: 0 20px;
      .msgbox {
        padding: 10px 0;
        p {
          color: #222;
          em {
            color: #9e9e9e;
          }
        }
        .img_box {
          margin: 10px;
        }
        .id_box {
          div {
            .no-img {
              width: 100px;
              height: 70px;
              margin: 25px auto;
            }
            img {
              width: 100%;
              height: auto;
            }
            span {
              display: block;
              width: 100%;
              height: 30px;
              line-height: 30px;
              background: #10aeff;
              color: #fff;
              font-size: 14px;
              text-align: center;
              position: absolute;
              bottom: 0;
            }
            span:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    p {
      padding: 5px 0;
      font-weight: 400;
    }
  }
}
.border_b {
  border-bottom: 1px solid #dddddd;
}
.camera_box {
  width: 100px;
  height: 80px;
  line-height: 80px;
}
.demo-upload-list {
  display: inline-block;
  width: 150px;
  height: 150px;
  text-align: center;
  line-height: 150px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 15px;
  img {
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.regis_box {
  width: 100%;
  text-align: center;
  margin-top: 50px;
  .regis_ent {
    padding: 0px;
    margin: 0px;
    height: 30px;
    line-height: 30px;
    width: 100px;
    border: medium none;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    font-family: 微软雅黑, 宋体;
    background-color: #d93600;
    color: #fff;
    outline: medium none;
    display: inline-block;
    font-size: 14px;
    border-radius: 4px;
    -moz-user-select: none;
  }

  .regis_ent:hover {
    text-decoration: none !important;
    background-color: #ff4400;
    color: #fff;
  }
}
</style>




// WEBPACK FOOTER //
// businessLeague.vue?ec33ef38